import { RepeaterBlockEdit } from '@plone-collective/volto-repeater-block/Edit';
import { repeaterBlockSchema } from '@plone-collective/volto-repeater-block/schema';
import RepeaterBlockView from '@plone-collective/volto-repeater-block/View';

import sliderSVG from '@plone/volto/icons/slider.svg';

const applyConfig = (config) => {
  config.blocks.blocksConfig['repeater-block'] = {
    id: 'repeater-block',
    title: 'Repeater',
    icon: sliderSVG,
    group: 'common',
    view: RepeaterBlockView,
    edit: RepeaterBlockEdit,
    blockSchema: repeaterBlockSchema,
    restricted: false,
    mostUsed: false,
    sidebarTab: 1,
  };

  config.settings['volto-repeater-block'] = {
    allowedBlocks: [],
    sources: {
      //  e.g:
      // facetSource: {
      //   title: 'Facet source',
      //   schema: repeaterSourceSchemaFacets,
      //   fetchFromSource: (sourceSettings) => {
      //     return {"MappingField1": "My value"}}
      //   },
      // },
    },
    mappings: {
      // e.g:
      // card: {
      //   facetSource: {
      //     title: 'title',
      //     url: 'url',
      //   },
      // },
    },
  };

  return config;
};

export default applyConfig;
